export const errors = {
    invalid_organization: 'Organisation inconnue',
    invalidEmail: 'Adresse e-Mail invalide. Format attendu : texte@exemple.fr',
    unknownEmail: 'Adresse e-Mail non reconnue',
    invalidValue: 'Le champ est requis',
    invalidNumber: 'Le champ ne peut contenir que des chiffres',
    invalidpercent: 'Le pourcentage doit être compris entre 0 et 100%',
    maxlength: 'La longueur du champ ne peut pas dépasser {requiredLength} caractères',
    mindate: 'La date ne peut pas être inférieure au {requiredDate}',
    maxdate: 'La date ne peut pas être supérieure au {requiredDate}',
    invaliddate: 'La date doit être à ce format : jj/mm/aaaa',
    invaliddaterange: 'La date de fin doit être supérieure à la date de début.',
    invalidPhoneFormat: 'Le format du numéro de téléphone n\'est pas valide',
    min: 'La valeur du champ doit être supérieure ou égale à {min}',
    max: 'La valeur du champ doit être inférieure ou égale à {max}',
    meteoinvalidcity: 'Ville introuvable',
    invalidpartnumber: 'Déjà utilisé',
    invalidSiret: 'Le numéro de SIRET n\'est pas valide',
    countrycodelength: 'La longueur du code pays doit être égale à 2',
    countrycodebadchars: 'Le code pays doit contenir uniquement des lettres',
    invalidcountrycode: 'Le code pays n\'est pas valide',
    controlkeylength: 'La longueur de la clé de contrôle doit être égale à 2',
    controlkeynotanumber: 'La clé de contrôle doit contenir uniquement des chiffres',
    controlkeynotinrange: 'La clé de contrôle doit être comprise entre 02 et 98',
    noemailcommission: 'La commission n\'a pas d\'adresse e-Mail renseignée',
    nullamount: 'Le montant doit être supérieur à 0€',
    loginexist: 'Le login est déjà utilisé par un autre bénéficiaire',
    invalidint : 'Le champ ne peut contenir que des chiffres',
    notgreaterthan : 'Le champ doit avoir une valeur supérieure à {value}',
    invalidNumberRange : 'Le champ doit avoir une valeur comprise entre {min} et {max}',
    invalidmatchpassword : 'Votre confirmation ne correspond pas au nouveau mot de passe.',
    isnotsameascurrentpassword: 'Le mot de passe actuel est différent du mot de passe en cours.',
    isnotoneofcomponentdynamiclistbyid: 'Le champ est requis',
    invalidformatpassword: 'Le mot de passe doit contenir au minimum 14 caractères avec une majuscule, une minuscule, un chiffre et un caractère spécial.',
    invalidurl: 'L\'url est invalide',
};
